export default () => {
    let gravityFormDropDown = document.querySelector('.zinnia-gravity-drop-down');

    if(gravityFormDropDown) {
        let dropDownContainer = document.createElement('div');
        let selectedItemWrapper = document.createElement('div');
        selectedItemWrapper.classList.add('js-zinnia-gravity-drop-down-selected-item');
        let dropDownWrapper = document.createElement('div');
        dropDownWrapper.classList.add('js-zinnia-gravity-drop-down-list');
        const selectedValue = jQuery('.zinnia-gravity-drop-down option[selected="selected"]').length ? jQuery('.zinnia-gravity-drop-down option[selected="selected"]').val() : '';
        Array.from(gravityFormDropDown.getElementsByTagName("option")).forEach((item, key) => {
            let dropDownItemName = item.innerText;
            let dropDownItemValue = item.value;
            let dropDownItem  = document.createElement('div');
            dropDownItem.innerText = dropDownItemName;
            dropDownItem.setAttribute('data-value', dropDownItemValue);
            dropDownItem.classList.add('js-zinnia-gravity-drop-down-list-item');
            dropDownWrapper.append(dropDownItem);
            if(selectedValue != '' ){
                selectedItemWrapper.innerHTML = (`<span>${selectedValue}</span><svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.23177 27.0011C5.47906 26.2643 5.47906 25.0698 6.23177 24.333L18.5675 12.2584C19.3202 11.5216 20.5406 11.5216 21.2933 12.2584L33.629 24.333C34.3817 25.0698 34.3817 26.2643 33.629 27.0011C32.8762 27.7379 31.6558 27.7379 30.9031 27.0011L19.9304 16.2606L8.9576 27.0011C8.20488 27.7379 6.98449 27.7379 6.23177 27.0011Z" fill="#00628B"/>
</svg>`);
            } else if(key === 0) {
                selectedItemWrapper.innerHTML = (`<span>${dropDownItemName}</span><svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.23177 27.0011C5.47906 26.2643 5.47906 25.0698 6.23177 24.333L18.5675 12.2584C19.3202 11.5216 20.5406 11.5216 21.2933 12.2584L33.629 24.333C34.3817 25.0698 34.3817 26.2643 33.629 27.0011C32.8762 27.7379 31.6558 27.7379 30.9031 27.0011L19.9304 16.2606L8.9576 27.0011C8.20488 27.7379 6.98449 27.7379 6.23177 27.0011Z" fill="#00628B"/>
</svg>`);
            }
        });
        dropDownContainer.append(selectedItemWrapper);
        dropDownContainer.append(dropDownWrapper);
        gravityFormDropDown.parentElement.append(dropDownContainer);
    }

    document.addEventListener('click', (event) => {
        let selectedItemWrapper = document.querySelector('.js-zinnia-gravity-drop-down-selected-item');
        if(event.target.matches('.js-zinnia-gravity-drop-down-list-item')) {
            if(selectedItemWrapper) {
                selectedItemWrapper.innerHTML = (`<span>${event.target.innerText}</span><svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.23177 27.0011C5.47906 26.2643 5.47906 25.0698 6.23177 24.333L18.5675 12.2584C19.3202 11.5216 20.5406 11.5216 21.2933 12.2584L33.629 24.333C34.3817 25.0698 34.3817 26.2643 33.629 27.0011C32.8762 27.7379 31.6558 27.7379 30.9031 27.0011L19.9304 16.2606L8.9576 27.0011C8.20488 27.7379 6.98449 27.7379 6.23177 27.0011Z" fill="#00628B"/>
                    </svg>`);
            }
            let value = event.target.getAttribute('data-value');
            if(gravityFormDropDown.querySelector('select')){
                gravityFormDropDown.querySelector('select').value = value;
            }
        }

        let dropDownWrapper = document.querySelector('.js-zinnia-gravity-drop-down-list');
        if(dropDownWrapper) {
            if(event.target.matches('.js-zinnia-gravity-drop-down-selected-item') || event.target.closest('.js-zinnia-gravity-drop-down-selected-item')) {
                dropDownWrapper.classList.toggle('active');
                if(selectedItemWrapper) {
                    selectedItemWrapper.classList.toggle('active');
                }
            }else{
                dropDownWrapper.classList.remove('active');
                selectedItemWrapper.classList.remove('active');
            }
        }
    });
};

